import { repository } from "~/clientInstance";
import type { WorkerPoolResource } from "../client/resources";

const getWorkerPoolIndex = async (ids?: string[]): Promise<WorkerPoolIndex> => {
    const idx: { [poolId: string]: WorkerPoolResource } = {};
    const pools = await repository.WorkerPools.all({ ids });
    if (pools) {
        pools.forEach((p) => (idx[p.Id] = p));
    }
    return idx;
};

interface WorkerPoolIndex {
    [poolId: string]: WorkerPoolResource;
}

export { getWorkerPoolIndex, WorkerPoolIndex };
